import {ApplicationRef, Component, EventEmitter, OnInit, Renderer2} from "@angular/core";
import {TunapayScript} from "./formas-pagamentos/tunapay.script";
import {ActivatedRoute} from "@angular/router";
import {TunapayService} from "../services/tunapay.service";
import {FormaDePagamento} from "../objeto/FormaDePagamento";
import {ITela} from "../objeto/ITela";

@Component({
  selector: 'app-tunnapay-global',
  templateUrl: './tunapay-global.component.html',
  styleUrls: ['./tunapay-global.component.scss']
})
export class TunapayGlobalComponent extends TunapayScript implements OnInit,  ITela {
  processando = true;
  msgErro: string;
  googlePayDisponivel = false;
  applePayDisponivel = false;
  formaPagamentoGooglePay: any;
  formaPagamentoApplePay: any;
  guid: string;
  dados: any = {}
  carregouDados  = false;
  carteira: string;
  tentativasCarregar = 0;
  retentativa: boolean;
  constructor(protected tunapayService: TunapayService, protected app: ApplicationRef,
              protected renderer: Renderer2, private activatedRoute: ActivatedRoute) {
    super(tunapayService, app, renderer)
    this.formaPagamentoGooglePay = new FormaDePagamento()
    this.formaPagamentoApplePay = new FormaDePagamento();
  }

  static abraModalPagamentoExterno(urlRedirect: string, carteira: string, isMobile: boolean, retentativa: boolean,
                                   cb: Function, cbControle?: Function ){
    let features = ""
    if(!isMobile){
      const screenWidth = window.screen.width,
        screenHeight = window.screen.height,
        width = 700,
        height = 500;

      // calcula posição central
      const left = (screenWidth - width) / 2;
      const top = (screenHeight - height) / 2;

      features  =  `width=${width},height=${height},left=${left},top=${top},resizable=no,scrollbars=no`
    }

    let url = `${urlRedirect}?c=${carteira}`;

    if(retentativa) url += "&r=1";

    const winRef = window.open(url, 'pagamentoCarteira', features)

    if(winRef){
      let finalizou = false;
      let timerAbaAberta: any;
      let onMessage: any;
      const finalizar = (result: any) => {
        if(finalizou) return;

        finalizou = true;
        clearInterval(timerAbaAberta);
        window.removeEventListener('message', onMessage);
        cb(result);
      }

      if(cbControle){
        cbControle({
          cancelar: () => {
            try {
              winRef.close();
            } catch (e) {}
            finalizar({cancelou: true});
          }
        });
      }

      // Escuta mensagens vindas do filho
      onMessage = (event) => {
        console.log('Mensagem recebida:', event);
        let dev = window.location.host.indexOf('localhost') >= 0 ||
          window.location.host.indexOf('ngrok') >= 0 ;

        if (event.data && event.data.status === 'done') {
          if(event.origin.indexOf('meucardapio.ai') >= 0 || dev){
            try {
              winRef.close();
            } catch (e) {}
            finalizar({executou: true});
          }
        }
      };
      window.addEventListener('message', onMessage);

      timerAbaAberta = setInterval(() => {
        if (winRef.closed) {
          finalizar({ fechou: true})
        }
      }, 1000);
      return null
    }  else {
      return 'popup foi bloqueado, verifique tente novamente'
    }
  }

  ngOnInit(): void {
    this.guid = this.activatedRoute.snapshot.params.guid;
    this.formaPagamentoGooglePay = new FormaDePagamento()
    this.formaPagamentoApplePay = new FormaDePagamento();

    this.carteira = this.activatedRoute.snapshot.queryParams.c;
    this.retentativa = this.activatedRoute.snapshot.queryParams.r != null;

    //Object.assign(this.formaPagamentoGooglePay, this.formaDePagamento)
    this.formaPagamentoGooglePay.carteiraDigital = 'GooglePay';

  //  Object.assign(this.formaPagamentoApplePay, this.formaDePagamento)
    this.formaPagamentoApplePay.carteiraDigital = 'ApplePay';
    this.carregueDadosPedido();
  }

  carregueDadosPedido(){
    this.tentativasCarregar++;
    this.tunapayService.obtenhaDadosTemporarios(this.guid).then( (dados: any) => {
      if(!dados || (!dados.sessionId && !this.retentativa)){
        if(this.tentativasCarregar > 30){
          this.msgErro = "Não foi possível carregar dados da sessão " + this.guid
          return;
        }
        return setTimeout(() => { this.carregueDadosPedido() }, 1000);
      }


      this.dados = dados;
      this.carregouDados = true;
      let dadosSessao = this.retentativa ? null :
        {sessionId: this.dados.sessionId, env: this.dados.env }

      this.inicializeTuna(this.guid, dadosSessao).then((err) => {
        if(!err){
          // Configura Google Pay após inicializar Tuna
          this.configureGooglePay();
          this.configureApplePay();

          if(this.retentativa){
            const sessionId = this.tunaInstance.sessionID;
            const  env = this.tunaInstance.env;
            this.tunapayService.atualizeDadosSessao(this.guid, { sessionId: sessionId, env: env}).then(() => {

            })
          }


        } else {
          this.processando = false;
          this.msgErro = err;
        }
      })
    }).catch((err) => {
      this.processando = false;
      this.carregouDados = false;
      this.msgErro = err || 'Não foi possivel obter dados pagamento';
    })
  }

  pagarComGooglePay(){
    return this.dados.carteiraDigital === 'GooglePay'
  }

  pagarComApplePay(){
    return this.dados.carteiraDigital === 'ApplePay'
  }

  private configureApplePay() {
    const applePaySettings = {
      buttom: {
        selector: '#applePayDiv',
        style: {
          buttonStyle: "black",
          type: "check-out",
          locale: "pt-BR",
          width: "10px",
          height: "10px",
          borderRadius: "10px",
          padding: "10px",
          boxSizing: "10px"
        }
      },
      applePayCallback: async (applePayPayload: any) => {
        try {
          console.log('retorno applePayPayload')
          console.log(applePayPayload)
          this.cartao.token = applePayPayload.details.token;
          //  this.cartao.bandeira = 'Apple Pay';
          this.cartao.descricaoPagamento = `Apple Pay`;
          this.cartao.externalProvider = 'ApplePay';

         // this.definiuCartao.emit(this.cartao);
          return true;
        } catch (error) {
          console.error('Erro no processamento Apple Pay:', error);
          return false;
        }
      },
      cart: {
        lineItems: [{
          label: "Pedido",
          amount: (this.dados.valorPagamento).toFixed(2)
        }],
        total: {
          label: "Total do Carrinho",
          amount: {value: (this.dados.valorPagamento).toFixed(2), currency: "BRL"}
        }
      },
      merchantId: 'merchant.uy.tunahmlg',
      displayName: 'fibo.meucardapio',
    };

    console.log(applePaySettings)

    this.tunaInstance.useApplePay(applePaySettings)
      .then((flag, err) => {
        console.log('Apple Pay  run: ' + flag);
        this.applePayDisponivel = flag;
        this.app.tick();
      })
      .catch((err: any) => {
        console.error('Erro detalhado ao configurar Apple Pay:', err);
        this.applePayDisponivel = false;
        this.app.tick();
      });
  }

  private configureGooglePay() {

    const merchantInfo = {
      merchantId: 'BCR2DN6TR7QYLIKK'
    };

    const transactionInfo = {
      transactionId: this.guid,
      totalPriceStatus: 'FINAL',
      totalPrice: this.dados.valorPagamento.toString(),
      currencyCode: "BRL",
      countryCode: "BR"
    };

    // Callback quando o pagamento for concluído
    const checkoutCallback = async (response: any) => {
      const payment: any = response.paymentMethodData;

      if (payment) {
        this.setDadosGooglPay(payment)
      } else {
        console.error("Erro ao processar o pagamento com Google Pay:", response);
      }
    };


    // Configura o Google Pay usando a API do Tuna
    this.tunaInstance.useGooglePay(
      '#google-pay-container', // ID do container do botão
      merchantInfo,
      checkoutCallback,
      null,
      transactionInfo
    )

    this.googlePayDisponivel = true;

  }

  async processarPagamento() {
    this.cartao.autenticouCarteiraDigital = true;
    this.cartao.valorPagamento = this.dados.valorPagamento;

    let resp: any = await this.tunapayService.atualizeDadosCartao(this.guid, this.cartao).catch((err) => {
       this.msgErro = err;
    })

    //  window.location.href = result.data.urlRetorno;

    if(resp){
      if (window.opener ){
        window.opener.postMessage(
          { status: 'done', msg: 'finalizei o pagamento' },
          this.dados.parentOrigin
        );
      }

      setTimeout(() => {
        window.close();
      }, 300)


    }
  }

  setDadosGooglPay(payment: any){
    //PAYMENT_GATEWAY     response.paymentMethodData.tokenizationData.type
    this.cartao.token =   payment.tokenizationData.token;
    this.cartao.bandeira = payment.info.cardNetwork;
    this.cartao.descricaoPagamento = `Google Pay (${payment.description})` ; //response.info.cardDetails so numeros

    if(payment.info){
      this.cartao.ultimosNumeros = payment.info.cardDetails;
      this.cartao.bandeira = payment.info.cardNetwork;
    }

    this.cartao.externalProvider = 'GooglePay';
    this.processarPagamento( );
   // this.definiuCartao.emit(this.cartao)

  }

  deveExibirTopo() {
    return false;
  }

  deveExibirMenu(){
    return false;
  }

  deveTerBordas() {
    return true;
  }

  deveExibirBannerTema() {
    return false;
  }
}
